import { InteractionRequiredAuthError } from "@azure/msal-browser"; // InteractionStatus from browser
import { msalInstance } from "@/index";

export async function getToken(scopes: string[]) {
  // Make it an async function
  const account = msalInstance.getActiveAccount(); // Get the active account

  if (!account) {
    throw new Error("No active account found. User might not be logged in.");
  }

  const accessTokenRequest = {
    scopes: scopes,
    account: account,
  };

  try {
    const response = await msalInstance.acquireTokenSilent(accessTokenRequest);
    return response.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      // Fallback to interactive method if silent acquisition fails
      const response = await msalInstance.acquireTokenPopup(accessTokenRequest);
      return response.accessToken;
    }

    throw error; // Rethrow other silent acquisition errors
  }
}
